import { jsx as _jsx } from "react/jsx-runtime";
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
export const SpeakerIdActiveIcon = ({ active }) => {
    if (active === undefined) {
        return null;
    }
    if (active === true) {
        return _jsx(CheckOutlined, { style: { color: 'var(--ant-color-success)' } });
    }
    return _jsx(CloseOutlined, { style: { color: 'var(--ant-color-error)' } });
};
